export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14099.4f1215e2.jpg";